import React from 'react'
import LgyLink from '../../../components/util/lgy-link/LgyLink'
import '../style/lgy-big-footer.scss'

const LgyBigFooter = () =>
  <footer className='lgy-big-footer usa-footer usa-footer-big usa-background-dark' role='contentinfo'>
    <div className='usa-footer-primary-section usa-grid'>
      <nav className='usa-footer-nav usa-width-three-fourths'>
        <ul className='usa-unstyled-list usa-width-one-third usa-footer-primary-content'>
          <li className='usa-footer-primary-link'>
            <h4>Public Tools</h4>
          </li>
          <li className='usa-footer-secondary-link'><LgyLink to='/lgyhub/guaranty-calculator' title='Home' aria-label='Home'>Guaranty Calculator</LgyLink></li>
          <li className='usa-footer-secondary-link'><LgyLink to='/lgyhub/condo-report' title='Home' aria-label='Home'>Condo Report</LgyLink></li>
        </ul>
        <ul className='usa-unstyled-list usa-width-one-third usa-footer-primary-content'>
          <li className='usa-footer-primary-link'>
            <h4>Helpful Links</h4>
          </li>
          <li className='usa-footer-secondary-link'><a href='https://www.benefits.va.gov/WARMS/pam26_7.asp'>Lenders Handbook</a></li>
          <li className='usa-footer-secondary-link'><a href='https://entp.hud.gov/caivrs/public/home.html'>CAIVRS</a></li>
          <li className='usa-footer-secondary-link'><a href='https://www.dfas.mil/'>Military Pay and Housing Allowance Charts</a></li>
          <li className='usa-footer-secondary-link'>
           <a href="https://www.benefits.va.gov/homeloans/appraiser.asp" rel="noopener noreferrer" target="_blank">Fee appraiser updates</a>
           </li>
		  <li className='usa-footer-secondary-link'>
			<a href='https://www.benefits.va.gov/HOMELOANS/resources_circulars.asp' rel="noopener noreferrer" target='_blank'>Circulars: Calendar Years 2021 to Present - VA Home Loans</a>
			</li>
        </ul>
        <ul className='usa-unstyled-list usa-width-one-third usa-footer-primary-content'>
          <li className='usa-footer-primary-link'>
            <h4>Get Help</h4>
          </li>
          <li className='usa-footer-secondary-link'><LgyLink to='/lgyhub/help' title='Home' aria-label='Home'>Frequently Asked Questions</LgyLink></li>
          <li className='usa-footer-secondary-link'><LgyLink to='/lgyhub/help/ticket' title='Home' aria-label='Home'>Contact us</LgyLink></li>
          <li className='usa-footer-secondary-link'><a href='https://www.oprm.va.gov/privacy/'>Privacy</a></li>
          <li className='usa-footer-secondary-link'><a href='https://www.veteranscrisisline.net/'>Veterans Crisis Line</a></li>
        </ul >
      </nav>
      <div className='usa-sign_up-block usa-width-one-fourth'>
        <div className='footer-seal'>
          <abbr title='Department of Veterans Affairs'>VA</abbr> | U.S. Department of Veterans Affairs
          </div>
      </div>
    </div>
  </footer>

export default LgyBigFooter